import React from 'react';
import {
  FormControl,
  Box,
  FormHelperText,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';

export default function OutputUriField({
  value,
  outputType,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  projectDatastores,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);

    if (
      [
        THIRD_PARTY_TYPES.REGIONAL.value,
        THIRD_PARTY_TYPES.TRAINML.value,
      ].includes(outputType)
    ) {
      setError(false);
    } else {
      const uriTest = Object.values(THIRD_PARTY_TYPES).find(
        (type) => type.value === outputType
      )?.uriTest;
      if (uriTest) {
        const valid = uriTest.test(newValue);
        setError(!valid);
      }
    }
  };

  const selected_type = Object.values(THIRD_PARTY_TYPES).find(
    (type) => type.value === outputType
  );
  const placeholder = selected_type ? selected_type.uriExample : '';

  if (outputType === THIRD_PARTY_TYPES.REGIONAL.value && projectDatastores) {
    return (
      <Box>
        <FormControl fullWidth>
          <InputLabel id='output-uri-label'>Datastore</InputLabel>
          <Select
            labelId='output-uri-label'
            id='output_uri'
            value={value || ''}
            label='Datastore'
            aria-describedby='output-uri-helper-text'
            onChange={handleChange}
            disabled={edit}
          >
            {projectDatastores.map((datastore) => (
              <MenuItem key={datastore.id} value={datastore.id}>
                {datastore.name}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText id='output-uri-helper-text'>
            Select the datastore
          </FormHelperText>
        </FormControl>
      </Box>
    );
  }

  if (outputType === THIRD_PARTY_TYPES.TRAINML.value) {
    return (
      <Box>
        <FormControl fullWidth>
          <InputLabel id='output-uri-label'>Entity Type</InputLabel>
          <Select
            labelId='output-uri-label'
            id='output_uri'
            value={value || ''}
            label='Entity Type'
            aria-describedby='output-uri-helper-text'
            onChange={handleChange}
            disabled={edit}
          >
            <MenuItem value='model'>Model</MenuItem>
            <MenuItem value='checkpoint'>Checkpoint</MenuItem>
            <MenuItem value='dataset'>Dataset</MenuItem>
          </Select>
          <FormHelperText id='output-uri-helper-text'>
            Select the entity type
          </FormHelperText>
        </FormControl>
      </Box>
    );
  }

  if (!outputType) {
    return null;
  }

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Output storage path'
          id='output_uri'
          aria-describedby='output-uri-helper-text'
          variant='outlined'
          fullWidth
          placeholder={placeholder}
          onChange={handleChange}
          error={Boolean(error)}
          value={value || ''}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='output-uri-helper-text'>
            Storage Path Invalid
          </FormHelperText>
        ) : (
          <FormHelperText id='output-uri-helper-text'>
            Enter the output storage path
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

